import { FieldSchema } from "../../../Schema";

export const createdBy: FieldSchema = {
  name: "createdBy",
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Created by", disabled: true, displayed: false },
};
